import { ref, onMounted, onUnmounted } from "vue";

const useIntersectionObserver = (targetRef, options = {}) => {
  const intersectionRatio = ref(0);
  let observer = null;

  const handleIntersection = (entries) => {
    if (entries?.length > 0) {
      intersectionRatio.value = entries[0].isIntersecting;
    }
  };

  onMounted(() => {
    if (options?.widthToInitialize ? window.innerWidth > options?.widthToInitialize : true) {
      observer = new IntersectionObserver(handleIntersection, options);
      if (targetRef.value) {
        observer.observe(targetRef.value);
      }
    }
  });

  onUnmounted(() => {
    if (observer) {
      observer.disconnect();
    }
  });
  return intersectionRatio;
};

export default useIntersectionObserver;
